import { createFileRoute, redirect, Navigate } from '@tanstack/react-router';
import { checkUserPermissions } from '@/components/Auth/checkUserPermissions';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/system-administrators/$systemadministratorId/',
)({
  component: SystemAdministratorRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkUserPermissions({
      permission: 'tenant:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function SystemAdministratorRedirect() {
  const { tenantId, systemadministratorId } = Route.useParams();
  const view = getDefaultView('systemadministrator');

  return (
    <>
      <DocumentHead
        titleKey="page.systemAdministrator.details.title"
        descriptionKey="page.systemAdministrator.details.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/system-administrators/$systemadministratorId/$view"
        params={{ tenantId, systemadministratorId, view }}
        replace
      />
    </>
  );
}
